export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-minus-circle-2e0ecab9742b03d1219290526e4efb5d.svg";